import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs";

export default class extends Controller {
    connect() {
        this.initializeSortable();
    }

    initializeSortable() {
        this.sortable = Sortable.create(this.element, {
            animation: 150,
            ghostClass: "bg-gray-200"
        })
    }
}
